import listViewStore from 'owa-mail-list-store/lib/store/Store';
import moveConversationToFocusedOrOther from '../conversations/moveConversationToFocusedOrOther';
import moveItemsToFocusedOrOther from '../items/moveItemsToFocusedOrOther';
export default function moveMailListRowsToFocusedOrOtherAction(rowKeys, originalTableViewId, actionSource) {
    var tableView = listViewStore.tableViews.get(originalTableViewId);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            moveConversationToFocusedOrOther(rowKeys, originalTableViewId, actionSource);
            break;
        case 1 /* Message */:
            moveItemsToFocusedOrOther(rowKeys, originalTableViewId, actionSource);
            break;
    }
}
//# sourceMappingURL=moveMailListRowsToFocusedOrOther.js.map